// CoursesList/index.js
import { connect } from 'react-redux';
import CoursesList from '../../components/CoursesList';
import { documentType } from '../../constants';

import {
  fetchAllCoursesForBranchDispatch,
  fetchAllDocumentsDispatch,
  openEditCoursePanelDispatch,
  courseEditClickDispatch,
  openEditCourseDialogDispatch,
  openDeleteCourseDialogDispatch,
  submitDeleteCourseRequestDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    courses: state.courses.coursesByBranch.items,
    documents: state.settings.allDocuments.items,
    openDeleteDialog: state.courses.deleteCourse.openDialog,
    courseToBeDeleted: state.courses.deleteCourse.course,
    errorMessage: state.courses.deleteCourse.errorMessage,
    isDeletingCourse: state.courses.deleteCourse.isSaving,
    loggedInUser: state.users.user.item
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllCoursesForBranch: (branchId) => {
      dispatch(fetchAllCoursesForBranchDispatch(branchId));
    },
    fetchAllDocuments: (branchId) => {
      dispatch(fetchAllDocumentsDispatch(documentType.DOCUMENT_LIBRARY, branchId));
    },
    handleCourseEditClick: (course) => {
      dispatch(openEditCourseDialogDispatch(true));
      dispatch(courseEditClickDispatch(course));
    },
    handleCourseRecordEditClick: (course) => {
      dispatch(openEditCoursePanelDispatch(true));
      dispatch(courseEditClickDispatch(course));
    },
    openDeleteCourseDialog: (open, course) => {
      dispatch(openDeleteCourseDialogDispatch(open, course));
    },
    submitDeleteCourseRequest: (course) => {
      dispatch(submitDeleteCourseRequestDispatch(course));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursesList);
